module.exports = __webpack_public_path__ + "img/75.a936f06.png";